import React from "react";

function CategorieTagComponent (props) {

    return false;
    if(!props.tags) {
        return false;
    }

    let items = props.tags.split(",");

    return <div className="tagCategory">
        {items.map((item, index) => (
            <h4 className='tag-item' key={index}>{item}</h4>
        ))}
    </div>
}

export default CategorieTagComponent;